const Footer = () => {
  return (
    <>
      {/* Footer */}
      {/* <footer className="content-footer footer bg-footer-theme">
        <div className="container-xxl d-flex flex-wrap justify-content-between py-3 flex-md-row flex-column">
          <div className="mb-2 mb-md-0">
            ارائه شده توسط
            <a
              href="https://radkit.ir/"
              target="_blank"
              className="footer-link fw-semibold ms-1"
              rel="noopener noreferrer"
            >
              رادکیت
            </a>
          </div>
          <div>
            <a
              href="https://rtl-theme.com"
              className="footer-link me-4"
              target="_blank"
              rel="noopener noreferrer"
            >
              لایسنس
            </a>
            <a
              href="https://rtl-theme.com"
              target="_blank"
              className="footer-link me-4"
            >
              قالب‌های بیشتر
            </a>

            <a
              href="https://v3dboy.ir/previews/html/frest/documentation"
              target="_blank"
              className="footer-link me-4"
              rel="noopener noreferrer"
            >
              مستندات
            </a>

            <a
              href="https://rtl-theme.com"
              target="_blank"
              className="footer-link d-none d-sm-inline-block"
              rel="noopener noreferrer"
            >
              پشتیبانی
            </a>
          </div>
        </div>
      </footer> */}
      {/* / Footer */}
    </>
  );
}

export default Footer;